import React from "react";
import {
  Dialog,
  DialogContent,
  Slide,
  IconButton,
  DialogTitle,
} from "@material-ui/core";
import Button from "./Button";

import CloseIcon from "@material-ui/icons/Close";
import { FORMAT_APY } from "../constants/constants";

import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";

import { withStyles } from "@material-ui/core/styles";
import { toFixed } from "../../../constants/constants";

const styles = (theme) => ({
  root: {
    flex: 1,
    display: "flex",
    width: "100%",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    padding: "30px",
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
      padding: "70px",
    },
    position: "relative",
  },
  paper: {
    background: theme?.colors?.swap?.background,
    borderRadius: "30px",
    boxShadow:
      "0px 10px 60px " + theme?.colors?.containerShadow + " !important",
  },
  modalRoot: {
    maxWidth: "640px",
    [theme.breakpoints.up("md")]: {
      borderRadius: "30px",
    },
  },
  modalContent: {
    padding: theme.spacing(3),
  },
  closeIcon: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
  },

  manageModalContent: {
    borderRadius: "34px !important",
    padding: "32px 48px 24px 48px",
    position: "relative",
  },
  manageModalBg: {
    background: "#000 0% 0% no-repeat padding-box",
    borderRadius: "34px",
    opacity: 0.09,
    position: "absolute",
    top: "4px",
    left: "0px",
    right: "7px",
    bottom: "6px",
    zIndex: 0,
  },
  modalHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1,
    width: "100%",
  },
  modalHeadingContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100%",
    padding: "8px 24px 0px",
  },
  modalHeadingLogoName: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  modalLg: {
    maxWidth: "553px",
  },
  modalHeadingLogo: {
    width: "35px",
    height: "35px",
    objectFit: "contain",
    marginRight: "5px",
  },
  manageModalHeadingAddress: {
    flex: 1,
    fontFamily: "Poppins",
    fontSize: "15px",
    letterSpacing: "1.35px",
    color: "#8bf5ff",
    cursor: "pointer",
    "&:hover": {
      opacity: 0.8,
    },
  },
  modalHeadingLg: {
    textAlign: "center",
    fontFamily: "Poppins",
    fontSize: "25px",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
    textTransform: "capitalize",
    fontWeight: 600,
  },
  modalCloseIcon: {
    width: "28px",
    height: "28px",
    position: "absolute",
    top: "25px",
    right: "25px",
    color: theme?.colors?.presale?.cardTitle,
    cursor: "pointer",
    "&:hover": {
      opacity: 0.8,
    },
  },
  manageModalNameInfo: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    padding: "10px 0px",
  },
  manageModalHeadingMd: {
    textAlign: "left",
    fontFamily: "Poppins",
    fontSize: "18px",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
    textTransform: "uppercase",
    marginBottom: "10px",
  },
  manageModalText: {
    textAlign: "left",
    fontFamily: "Poppins",
    fontSize: "14px",
    letterSpacing: "0px",
    color: "#A0A0A0",
    marginBottom: "20px",
  },
  manageModalSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    height: "65px",
    marginBottom: "40px",
  },
  manageModalHeadingSm: {
    textAlign: "center",
    fontFamily: "Poppins",
    fontSize: "14px",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
  },
  manageModalNameId: {
    padding: "10px 20px 6px 20px",
    background: "#A0A0A0 0% 0% no-repeat padding-box",
    borderRadius: "8px",
    textAlign: "left",
    fontFamily: "Poppins",
    fontSize: "18px",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
  },
  manageModalSell: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "100%",
    padding: "10px 0px",
  },
  manageModalDivider: {
    position: "absolute",
    left: "50%",
    height: "240px",
    width: "2px",
    backgroundColor: theme?.colors?.presale?.cardTitle,
    [theme.breakpoints.down("sm")]: {
      position: "relative",
      top: "50%",
      left: 0,
      width: "100%",
      height: "2px",
    },
  },
  poolDetailsInfoList: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  poolDetailsHeading: {
    display: "flex",
    width: "100%",
    marginBottom: "24px",
    fontFamily: "Poppins",
    fontSize: "18px",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
  },
  poolDetailsLine: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "16px",
  },
  poolDetailsIndex: {
    fontFamily: "Poppins",
    fontSize: "15px",
    letterSpacing: "0px",
    color: "#A0A0A0",
  },
  buttonsContainer: {
    display: "flex",
    gap: "16px",
    justifyContent: "center",
    marginTop: "48px",
    [theme.breakpoints.down("sm")]: {
      marginTop: "24px",
    },
  },
  poolDetailsValue: {
    fontFamily: "Poppins",
    fontSize: "15px",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
  },
  poolDetailsModalBody: {
    zIndex: 1,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  manageModalBody: {
    zIndex: 1,
    width: "100%",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridGap: "20px",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
    },
  },
});

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const PoolDetailsModal = ({
  modalOpen,
  onClose,
  pool,
  onConfirm,
  onApprove,
  classes,
}) => {
  return (
    <Dialog
      classes={{ paper: classes.paper, paperWidthSm: classes.modalRoot }}
      open={modalOpen}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      aria-labelledby="pool-details-modal"
      aria-describedby="pool-details-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle disableTypography className={classes.modalHeader}>
        <div className={classes.modalHeadingContainer}>
          <div className={classes.modalHeadingLogoName}>
            <img
              src={`/tokens/${pool?.token?.address}.png`}
              alt="logo"
              className={classes.modalHeadingLogo}
            />
            <span className={classes.modalHeadingLg}>
              Staking Reward Details
            </span>
          </div>
        </div>
        <IconButton
          aria-label="close"
          className={classes.modalCloseIcon}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent className={classes.manageModalContent}>
        <div className={classes.poolDetailsInfoList}>
          <div className={classes.poolDetailsHeading}>Details</div>
          <div className={classes.poolDetailsLine}>
            <div className={classes.poolDetailsIndex}>TVL</div>
            <div className={classes.poolDetailsValue}>
              ${parseFloat(pool?.tvl?.toFixed(2) || "0")?.toLocaleString()}
            </div>
          </div>
          <div className={classes.poolDetailsLine}>
            <div className={classes.poolDetailsIndex}>Weight</div>
            <div className={classes.poolDetailsValue}>{(pool?.weight / 1000 * 100)}%</div>
          </div>
          <div className={classes.poolDetailsLine}>
            <div className={classes.poolDetailsIndex}>Pending Rewards</div>
            <div className={classes.poolDetailsValue}>
              {toFixed(pool?.pending, 18, 6)} {"BUIDL"}
            </div>
          </div>
          <div className={classes.poolDetailsLine}>
            <div className={classes.poolDetailsIndex}>Pool APY</div>
            <div className={classes.poolDetailsValue}>
              {FORMAT_APY(pool?.apy || 0) || 0}%
            </div>
          </div>
          <div className={classes.poolDetailsLine}>
            <div className={classes.poolDetailsIndex}>My Liquidity</div>
            <div className={classes.poolDetailsValue}>
              {toFixed(pool?.staked, pool?.token?.decimals, 2)}{" "}
              {pool?.token?.symbol}
            </div>
          </div>

          <div className={classes.buttonsContainer}>
            {pool?.approved ? (
              <Button
                classes={{
                  root: classes.poolButton,
                  label: classes.buttonLabel,
                }}
                onClick={() => {
                  onConfirm();
                }}
                text="Stake"
              />
            ) : (
              <Button
                classes={{
                  root: classes.poolButton,
                  label: classes.buttonLabel,
                }}
                onClick={() => {
                  onApprove();
                }}
                text="Approve"
              />
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default withNamespaces()(
  withRouter(withStyles(styles)(PoolDetailsModal))
);
